export const formatEpochToDate = (epochTime: any) => {
    const date = new Date(epochTime * 1000); // Convert seconds to milliseconds
    return date.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
  };